export default {

    init() {
        // Event handler for pagination buttons
        $('.partners-pagination-buttons').on('click', '.partners-load-more-button', function () {
          const targetPage = parseInt($(this).data('page'));
          PartnersperformSearchAndPagination(targetPage);
        });
  
        // Function to perform AJAX request and update partners
        function PartnersperformSearchAndPagination(targetPage = 1, isFirstCall = false) {
          $('.partners-wrap').addClass('loading');
          const selectedFilter = $('input[name="taxonomy_filter[]"]:checked').map(function () {
            return this.value;
          }).get();
          const selectedTaxonomy = $('input[name="taxonomy_filter[]"]:checked').first().data('taxonomy') || '';

          const selectedTaxonomyTitle = $('select[name="taxonomy_title_filter"]').val(); // Get the selected taxonomy title
          const searchTerm = $('input[name="partners_search_filter"]').val();
  
          $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
              action: 'load_partners',
              selected_taxonomy: selectedTaxonomy,  // Pass selected taxonomy
              selected_filter: selectedFilter,      // Pass selected filter (term slug)
              selected_taxonomy_title: selectedTaxonomyTitle, // Pass the selected taxonomy title
              partners_search_filter: searchTerm,
              partnersPaged: targetPage,
            },
            success: function (response) {
              const parsedResponse = JSON.parse(response);
  
              // Replace existing content with new partners
              $('.partners-wrap').html(parsedResponse.html);
              // Update pagination buttons outside the .partners-wrap div
              $('.partners-pagination-buttons').html(parsedResponse.pagination);
  
              // Remove the loading class once the AJAX request is complete
              $('.partners-wrap').removeClass('loading');
  
              if (!isFirstCall) {
                $('html, body').animate({
                  scrollTop: $('.partners-filters').offset().top,
                }, 1000);
              }
            },
            error: function (errorThrown) {
              console.log(errorThrown);
            },
          });
        }
  
        PartnersperformSearchAndPagination(1, true);
  
        // Show the reset button when interacting with any filter
        function showResetButton() {
          $('.clear-filter-button').show();
        }
  
        // Event handler for Enter key in search field
        $('input[name="partners_search_filter"]').on('keypress', function (e) {
          if (e.which === 13) {
            PartnersperformSearchAndPagination(1);
          }
        });
  
        // Event handler for button click
        $('#partnersSearch').on('click', function () {
            PartnersperformSearchAndPagination(1);
        });

        $('.filter-dropdown input[type="checkbox"]').on('change', function() {
          PartnersperformSearchAndPagination(1);
          showResetButton();
      });
  
        // Event handler for change in filter selects
        $('.filter-select').on('change', function () {
            PartnersperformSearchAndPagination(1);
            showResetButton(); // Show reset button when filter is changed
        });
  
        // Event handler for change in taxonomy title select
        $('.filter-select-title').on('change', function () {
            PartnersperformSearchAndPagination(1);
            showResetButton(); // Show reset button when title filter is changed
        });
  
        // Event handler for input focus
        $('input[name="partners_search_filter"]').on('focus', function() {
          showResetButton();
          $(this).addClass('focused');
        });
  
        // Event handler for clear filter button click
        $('.clear-filter-button').on('click', function() {
  
          // Reset both taxonomy filters
          $('input[name="partners_search_filter"]').val('');
          $('input[name="partners_search_filter"]').removeClass('focused');
          //$('select[name="taxonomy_filter"]').prop('selectedIndex', 0);
          $('input[name="taxonomy_filter[]"]').prop('checked', false);
          $('#select-all').prop('checked', false);
          $('.dropdown-toggle .dropdown-text').text('Select all that apply');

          //$('select[name="taxonomy_title_filter"]').prop('selectedIndex', 0); // Reset taxonomy title filter
  
          $(this).hide();
          PartnersperformSearchAndPagination(1);
        });

        $('input[name="partners_search_filter"]').on('keyup', function() {
          let value = $(this).val();
          if (value.length > 0) {
            $('.search-icon-container .icon-search').hide();
            $('.search-icon-container .icon-clear').show();
          } else {
            $('.search-icon-container .icon-search').show();
            $('.search-icon-container .icon-clear').hide();
            PartnersperformSearchAndPagination(1);
          }
        });
        
        $('.search-icon-container .icon-clear').on('click', function(e) {
          $('input[name="partners_search_filter"]').val('');
          $('.search-icon-container .icon-search').show();
          $('.search-icon-container .icon-clear').hide();
          $('input[name="partners_search_filter"]').blur();
          PartnersperformSearchAndPagination(1);

          if ($('input[name="taxonomy_filter[]"]:checked').length === 0) {
            $('.clear-filter-button').hide();
          }
        });
        

          // Toggle dropdown when button is clicked
          $('.dropdown-toggle').on('click', function (e) {
              e.stopPropagation();
              $(this).parent().toggleClass('open');
          });
      
          // Close dropdown if clicked outside
          $(document).on('click', function () {
              $('.filter-dropdown').removeClass('open');
          });
      
          // Prevent dropdown from closing when clicking inside
          $('.dropdown-menu').on('click', function (e) {
              e.stopPropagation();
          });
      
          // Handle "Select All" functionality
          $('#select-all').on('change', function () {
              $('.filter-checkbox').prop('checked', this.checked);
              updateDropdownText();
          });
      
          // Update dropdown text with selected options
          $('.filter-checkbox').on('change', function () {
              if ($('.filter-checkbox:checked').length === $('.filter-checkbox').length) {
                  $('#select-all').prop('checked', true);
              } else {
                  $('#select-all').prop('checked', false);
              }
              updateDropdownText();
          });
      
          // Function to update dropdown button text
          function updateDropdownText() {
              let selected = $('.filter-checkbox:checked').map(function () {
                  return $(this).parent().text().trim();
              }).get();
      
              let text = selected.length > 0 ? selected.join(', ') : "Select all that apply";
              $('.dropdown-toggle .dropdown-text').html(text);
          }
      
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/partners.js